/* global */

import './style.less';
import AdminEmployeesModalCourseController from 'modals/employeesCourses';
import adminEmployeesModalCourseTemplate from 'modals/employeesCourses/index.html';

export default function($log, $stateParams, $location, $uibModal, $state) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.stateParams = $stateParams;

  switch ($stateParams.tab) {
    case 'all':
      vm.activeTab = 1;
      break;
    default:
      vm.activeTab = 0;
  }

  vm.changeTab = tab => $location.search('tab', tab);

  vm.assignCourse = () => {
    const modalInstance = $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalCourseTemplate,
      controller: AdminEmployeesModalCourseController,
      resolve: {
        selectedEmployees: function() {
          return [{ profile_uid: $stateParams.employeeID }];
        }
      }
    });

    modalInstance.result.then($state.reload);
  };

  function activate() {
    $log.debug('Admin Employees Employee Courses Activated');
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/employee/courses/index.js